import { type ReactNode, useCallback, useContext } from "react";
import * as HoverCard from ".";

const OPEN_DELAY = 750;
const CLOSE_DELAY = 500;

interface Props {
  payload: HoverCard.ContentPayload;
  children: ReactNode;
  className?: string;
}

export default function HoverCardTrigger(props: Props) {
  const { dispatch } = useContext(HoverCard.Context);
  const { payload, children, className } = props;

  const handleEnter = useCallback(
    (event) => {
      dispatch({ type: HoverCard.ActionType.ClearTimeout });

      const openDelayTimeoutId = window.setTimeout(() => {
        dispatch({
          type: HoverCard.ActionType.Open,
          payload: {
            ...payload,
            triggerEl: event.target,
          },
        });
      }, OPEN_DELAY);

      dispatch({
        type: HoverCard.ActionType.SetTimeout,
        payload: { timeoutId: openDelayTimeoutId },
      });
    },
    [dispatch, props],
  );

  const handleLeave = useCallback(() => {
    dispatch({ type: HoverCard.ActionType.ClearTimeout });

    const closeDelayTimeoutId = window.setTimeout(() => {
      dispatch({ type: HoverCard.ActionType.Close });
    }, CLOSE_DELAY);

    dispatch({
      type: HoverCard.ActionType.SetTimeout,
      payload: { timeoutId: closeDelayTimeoutId },
    });
  }, [dispatch, props]);

  return (
    <button
      aria-controls={HoverCard.ariaPrefix.dialog + payload.id}
      className={className}
      onBlur={handleLeave}
      onFocus={handleEnter}
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
    >
      {children}
    </button>
  );
}
